import swal from 'sweetalert';
import $ from 'jquery';
import I18n from 'i18n-js';
import select2 from 'select2';
import 'javascripts/i18n/translations';
import {toastr} from './notifications';

I18n.locale = window.I18n.locale;

document.addEventListener("turbolinks:before-cache", function () {
    $('[data-toggle="m-tooltip"]').tooltip('hide');
    $('.selectpicker').selectpicker('destroy');
});

$(document).on('turbolinks:load', function () {


    if($('#select_unit_id').val() !== undefined){
        getCentByUnit();

    }

    $('#select_unit_id').on('change', function () {
        getCentByUnit();
    });

    if(!invalidString($('#reupload-file').val())){
        swal({
            title: "Seleccionar archivo",
            text: "Por favor seleccione el archivo nuevamente.",
            icon: 'warning',
            button: I18n.t('messages.ok')
        });
    }

    $('#select_faculty_id').on('change', function () {
        $.ajax({
            type: 'GET',
            url: '/get_program_by_faculty/' + $("#select_faculty_id").val(),
            contentType: "application/json",
            dataType: 'json',
            data: {clave_anexo: $("#clave_anexo").val()},
            success: function (result) {
                if (result) {
                    var array = [];
                    array.push('<option value="">Selecciona una carrera</option>');

                    $.each(result, function (i, val) {
                        array.push('<option value="' + val.IdProgramaEducativo + '">' + val.Descripcion + '</option>');
                    });

                    $('#select_program_id').empty().append(array.join(''));
                }
            },
            error: function (error) {
                $("#select_program_id").empty()
                $("#select_program_id").append($("<option></option>").attr("value", '').text('Selecciona una carrera'))
            }
        });
    });

    function getCentByUnit(){
        $.ajax({
            type: 'GET',
            url: '/get_cent_by_unit',
            contentType: "application/json",
            dataType: 'json',
            data: {unit_id: $("#select_unit_id").val()},
            success: function (result) {
                if (result) {
                    var array = [];

                    array.push('<option value="">Selecciona un centro</option>');
                    $.each(result, function (i, val) {
                        if($("#hidden_centro_id").val() == val.Id_UnidadPres){
                            array.push('<option selected="selected" value="' + val.Id_UnidadPres + '">' + val.Id_UnidadPres + ' - ' + val.Descripcion + '</option>');
                        }else{
                            array.push('<option value="' + val.Id_UnidadPres + '">' + val.Id_UnidadPres + ' - ' + val.Descripcion + '</option>');
                        }
                    });

                    $('#select_centro_id').empty().append(array.join(''));
                }
            }
        });
    }

    function fileEnlace() {

        var fileInput = document.getElementById("idFileEnlace");


        try {
            if (fileInput.files[0].size > 2000000) {
                swal({
                    title: "Archivo demasiado grande",
                    text: "El archivo debe pesar menos de 2mb",
                    icon: 'warning',
                    button: I18n.t('messages.ok')
                });

                document.getElementById("idFileEnlace").value = null;
            }
        } catch (e) {

        }
    };

    function fileSaliente() {

        var fileInput = document.getElementById("idFileSaliente");

        try {
            if (fileInput.files[0].size > 2000000) {
                swal({
                    title: "Archivo demasiado grande",
                    text: "El archivo debe pesar menos de 2mb",
                    icon: 'warning',
                    button: I18n.t('messages.ok')
                });

                document.getElementById("idFileSaliente").value = null;
            }
        } catch (e) {

        }
    }

    function fileIne() {

        var fileInput = document.getElementById("idFileIne");

        try {
            if (fileInput.files[0].size > 2000000) {
                swal({
                    title: "Archivo demasiado grande",
                    text: "El archivo debe pesar menos de 2mb",
                    icon: 'warning',
                    button: I18n.t('messages.ok')
                });
                document.getElementById("idFileIne").value = null;

            }
        } catch (e) {

        }
    };

    function fileOficio() {

        var fileInput = document.getElementById("idFileOficio");
        try {
            if (fileInput.files[0].size > 2000000) {
                swal({
                    title: "Archivo demasiado grande",
                    text: "El archivo debe pesar menos de 2mb",
                    icon: 'warning',
                    button: I18n.t('messages.ok')
                });
                document.getElementById("idFileOficio").value = null;

            }
        } catch (e) {

        }
    };

    function fileRepresentante() {


        var fileInput = document.getElementById("idFileRepresentante");

        try {
            if (fileInput.files[0].size > 2000000) {
                swal({
                    title: "Archivo demasiado grande",
                    text: "El archivo debe pesar menos de 2mb",
                    icon: 'warning',
                    button: I18n.t('messages.ok')
                });
                document.getElementById("idFileRepresentante").value = null;

            }
        } catch (e) {

        }
    };

    function fileParticipantes() {


        var fileInput = document.getElementById("idFileParticipantes");

        try {
            if (fileInput.files[0].size > 2000000) {
                swal({
                    title: "Archivo demasiado grande",
                    text: "El archivo debe pesar menos de 2mb",
                    icon: 'warning',
                    button: I18n.t('messages.ok')
                });
                document.getElementById("idFileParticipantes").value = null;

            }
        } catch (e) {

        }
    };

    function fileTestigo() {


        var fileInput = document.getElementById("idFileTestigo");

        try {
            if (fileInput.files[0].size > 2000000) {
                swal({
                    title: "Archivo demasiado grande",
                    text: "El archivo debe pesar menos de 2mb",
                    icon: 'warning',
                    button: I18n.t('messages.ok')
                });
                document.getElementById("idFileTestigo").value = null;

            }
        } catch (e) {

        }
    };

    function fileEntrante() {


        var fileInput = document.getElementById("idFileEntrante");

        try {
            if (fileInput.files[0].size > 2000000) {
                swal({
                    title: "Archivo demasiado grande",
                    text: "El archivo debe pesar menos de 2mb",
                    icon: 'warning',
                    button: I18n.t('messages.ok')
                });
                document.getElementById("idFileEntrante").value = null;

            }
        } catch (e) {

        }
    };

    function fileRequisicion() {
        var fileInput = document.getElementById("requisicion_documento_requisicion");

        try {
            if (fileInput.files[0].size > 2000000) {
                swal({
                    title: "Archivo demasiado grande",
                    text: "El archivo debe pesar menos de 2mb.",
                    icon: 'warning',
                    button: I18n.t('messages.ok')
                });
                document.getElementById("requisicion_documento_requisicion").value = null;
            }
            if (fileInput.files[0].type !== 'application/pdf') {
                swal({
                    title: "Tipo de archivo incompatible",
                    text: "El archivo debe de ser pdf.",
                    icon: 'warning',
                    button: I18n.t('messages.ok')
                });
                document.getElementById("requisicion_documento_requisicion").value = null;
            }
        } catch (e) {}
    }

    $('#idFileEnlace').on("change", fileEnlace);
    $('#idFileSaliente').on("change", fileSaliente);
    $('#idFileIne').on("change", fileIne);
    $('#idFileOficio').on("change", fileOficio);
    $('#idFileRepresentante').on("change", fileRepresentante);
    $('#idFileParticipantes').on("change", fileParticipantes);
    $('#idFileTestigo').on("change", fileTestigo);
    $('#idFileEntrante').on("change", fileEntrante);
    $('#requisicion_documento_requisicion').on("change", fileRequisicion);


    $('#asignar_na').hide();
    $('#observacionesProceso').hide();

    // if ($('#no_data').is(':visible')){
    //     $('#new_record').show()
    // }else{
    //     $('#new_record').hide()
    // }

    if ($('#checkbox_proceso_finalizado').is(':checked')){
        $('#ActaFirmada').show()
    }else{
        $('#ActaFirmada').hide()
    }
    $('#checkbox_proceso_finalizado').on("change", function () {
        if ($('#checkbox_proceso_finalizado').is(':checked')){
            $('#ActaFirmada').show()
        }else{
            $('#ActaFirmada').hide()
        }
    })


    if ($('#tieneObservaciones').val() == 'true'){
        $('#observacionesProceso').show();
    }else{
        $('#observacionesProceso').hide();
    }
    $('#tieneObservaciones').on("change", function () {
        if ($('#tieneObservaciones').val() == 'true'){
            $('#observacionesProceso').show();
        }else{
            $('#observacionesProceso').hide();
        }
    })

    if ($("#primertd").length > 0) {
        $("#aplica option[value='0']").remove()
    } else {
        $("#aplica").add(new Option('N/A', '0'))
    }
    // Custom search field for table content
    $('.search-field').on('change', function () {
        let $this = $(this);
        $this.toggleClass('expand-input', $this.val() ? true : false);
    });

    $('[data-toggle="tooltip"]').tooltip();

    $('.select-process').click(function (event) {
        let $this = $(this);
        let process_id = $(this).data('process_id');
        let authenticityToken = $('[name="csrf-token"]')[0] && $('[name="csrf-token"]')[0].content;

        $.ajax({
            url: `/api/v1/employees/update_user`,
            data: {
                user: {current_process_id: process_id},
                authenticity_token: authenticityToken
            },
            type: 'PUT',
            dataType: 'json',
            success: function (data) {
                $('.m-menu__item').tooltip('disable');
                $this.parent().tooltip('enable');
                toastr.success(I18n.t('messages.process_selected'));
                $('.title-select-process').html($this.children('span').html());
                location.reload();
            },
            error: function (error) {
                console.log(error);
                toastr.warning(I18n.t('messages.try_again'));
            }
        });
    });

    // Sweet Alert modal for delete elements
    $('.btn-destroy').click(function (event) {
        let element, resource, resourceId, resourceMsg, row, url, authenticityToken;
        element = $(this);
        resource = element.data('resource');
        resourceId = element.data('resource-id');
        resourceMsg = element.data('resource-message');
        url = `/${resource}/${resourceId}`;
        authenticityToken = $('[name="csrf-token"]')[0] && $('[name="csrf-token"]')[0].content;
        swal(resourceMsg, {
            icon: 'warning',
            buttons: {
                cancel: I18n.t('messages.cancel'),
                confirm: {
                    text: I18n.t('messages.delete'),
                    closeModal: true
                }
            }
        }).then(function (isConfirm) {
            if (!isConfirm) {
                return;
            }
            $('#MyModal').modal('show')
            $.ajax({
                url: url,
                data: {authenticity_token: authenticityToken},
                type: 'DELETE',
                dataType: 'json',
                success: function (data) {
                    $('#MyModal').modal('hide')
                    swal({
                        title: I18n.t('messages.done'),
                        text: I18n.t('messages.deleted'),
                        icon: 'success',
                        button: I18n.t('messages.ok')
                    }).then(function () {
                        location.reload()
                    });
                },
                error: function (error) {
                    let message = I18n.t('messages.try_again');
                    if (error.responseJSON && error.responseJSON.message) {
                        message = error.responseJSON.message;
                    }
                    swal(I18n.t('messages.error'), message, 'error');
                }
            });
        });
    });

    $('#complete').click(function (event) {
        if ($('#no_data').is(':visible')) {
            swal({
                title: "Formulario incompleto",
                text: "No hay registros",
                icon: 'warning',
                button: I18n.t('messages.ok')
            });
        } else {
            let element, resource, resourceId, resourceMsg, row, url, authenticityToken;
            element = $(this);
            resource = element.data('resource');
            resourceId = element.data('resource-id');
            resourceMsg = element.data('resource-message');
            url = `/${resource}/${resourceId}`;
            authenticityToken = $('[name="csrf-token"]')[0] && $('[name="csrf-token"]')[0].content;
            swal(resourceMsg, {
                icon: 'warning',
                buttons: {
                    cancel: I18n.t('messages.cancel'),
                    confirm: {
                        text: "Finalizar",
                        closeModal: true
                    },
                }
            }).then(function (isConfirm) {
                if (isConfirm == null) {
                    return;
                }
                $.ajax({
                    url: url,
                    data: {
                        authenticity_token: authenticityToken,
                        aplica: $('#aplica').val(),
                        proceso_entrega_recepcion_id: $('#proceso_entrega_recepcion_id').val()
                    },
                    type: 'GET',
                    dataType: 'json',
                    success: function (data) {
                        swal({
                            title: I18n.t('messages.done'),
                            text: "Finalizado",
                            icon: 'success',
                            button: I18n.t('messages.ok')
                        }).then(function () {
                                $.ajax({
                                    url: `/reporte/${resourceId}/${false}/reporte`,
                                    data: {
                                        authenticity_token: authenticityToken
                                    },
                                    type: 'GET',
                                    dataType: 'json',
                                    success: function (data) {
                                        window.location.href = '/entrega_recepcion_anexos/' + $('#proceso_entrega_recepcion_id').val()
                                    },
                                    error: function (error) {
                                        let message = I18n.t('messages.try_again');
                                        if (error.responseJSON && error.responseJSON.message) {
                                            message = error.responseJSON.message;
                                        }
                                        console.log(error)
                                        swal(I18n.t('messages.error'), message, 'error');
                                    }
                                });
                        });
                    },
                    error: function (error) {
                        let message = I18n.t('messages.try_again');
                        if (error.responseJSON && error.responseJSON.message) {
                            message = error.responseJSON.message;
                        }
                        swal("Error", message, 'error');
                    }
                });
            }, function (e) {
                console.log(e)
            });
        }
    });


    $('#save_item').click(function (event) {
        let element, resource, resourceId, resourceTable, resourceMsg, row, url, authenticityToken;
        element = $(this);
        resource = element.data('resource');
        resourceId = element.data('resource-id');
        resourceTable = element.data('resource-table');
        resourceMsg = element.data('resource-message');
        url = `/${resource}/${resourceId}`;
        authenticityToken = $('[name="csrf-token"]')[0] && $('[name="csrf-token"]')[0].content;
        swal(resourceMsg, {
            icon: 'warning',
            buttons: {
                cancel: I18n.t('messages.cancel'),
                confirm: {
                    text: "Guardar",
                    closeModal: true
                },
            }
        }).then(function (isConfirm) {
            if (isConfirm == null) {
                return;
            }
            $('#MyModal').modal('show')
            var formData = new FormData();
            formData.append('authenticity_token', authenticityToken);
            formData.append('table', element.data('resourceTable'));
            formData.append('aplica', $('#aplica').val());
            formData.append('observaciones', $('#observaciones').val());

            var file = document.getElementById("excel_file");

            if (file) {
                formData.append('excel_file', file.files[0]);
            }
            $.ajax({
                url: url,
                type: 'PUT',
                data: formData,
                contentType: false,
                enctype: 'multipart/form-data',
                processData: false,
                success: function (data) {
                    $('#MyModal').modal('hide')
                    swal({
                        title: I18n.t('messages.done'),
                        text: "Guardado",
                        icon: 'success',
                        button: I18n.t('messages.ok')
                    }).then(function () {
                        //window.location.href='/entrega_recepcion_anexos/' + $('#proceso_entrega_recepcion_id').val()
                        window.location.reload();
                    });
                },
                error: function (error) {
                    console.log(error)
                    let message = "No puedes realizar esta acción";
                    if (error.responseJSON && error.responseJSON.message) {
                        message = error.responseJSON.message;
                    }
                    swal("Error", message, 'error');
                }
            });
        }, function (e) {
            console.log(e)
        });
    });

    // Sweet Alert modal for delete elements
    $('#delete_image').click(function (event) {
        let element, resource, resourceId, resourceData, url, authenticityToken;
        element = $(this);
        resource = element.data('resource');
        resourceId = element.data('resource-id');
        resourceData = element.data('resource-data')
        url = `/${resource}/${resourceId}/${resourceData}`;
        authenticityToken = $('[name="csrf-token"]')[0] && $('[name="csrf-token"]')[0].content;
        $.ajax({
            url: url,
            data: {authenticity_token: authenticityToken},
            type: 'POST',
            dataType: 'json',
            success: function (data) {
                location.reload()
            },
            error: function (error) {
                let message = I18n.t('messages.try_again');
                if (error.responseJSON && error.responseJSON.message) {
                    message = error.responseJSON.message;
                }
                swal(I18n.t('messages.error'), message, 'error');
            }
        });
    });

    $('#delete_image_controller').click(function (event) {
        let element, resource, resourceId, resourceData, url, authenticityToken;
        element = $(this);
        resource = element.data('resource');
        resourceId = element.data('resource-id');
        resourceData = element.data('resource-data')
        url = `/remove_image_controller/${resource}/${resourceId}/${resourceData}`;
        authenticityToken = $('[name="csrf-token"]')[0] && $('[name="csrf-token"]')[0].content;
        $.ajax({
            url: url,
            data: {authenticity_token: authenticityToken},
            type: 'POST',
            dataType: 'json',
            success: function (data) {
                location.reload()
            },
            error: function (error) {
                let message = I18n.t('messages.try_again');
                if (error.responseJSON && error.responseJSON.message) {
                    message = error.responseJSON.message;
                }
                swal(I18n.t('messages.error'), message, 'error');
            }
        });
    });

    $('#delete_file').click(function (event) {
        let element, resource, resourceId, resourceData, url, url_new, authenticityToken;
        element = $(this);
        resource = element.data('resource');
        resourceId = element.data('resource-id');
        resourceData = element.data('resource-data');
        console.log(resourceData)
        url = `/${resource}/${resourceId}`;
        url_new = `/${resource}/new?entrega_recepcion_anexo_id=${resourceData}`
        authenticityToken = $('[name="csrf-token"]')[0] && $('[name="csrf-token"]')[0].content;
        $.ajax({
            url: url,
            data: {authenticity_token: authenticityToken},
            type: 'DELETE',
            dataType: 'json',
            success: function (data) {
                // location.reload()
                window.location.href = url_new
            },
            error: function (error) {
                let message = I18n.t('messages.try_again');
                if (error.responseJSON && error.responseJSON.message) {
                    message = error.responseJSON.message;
                }
                swal(I18n.t('messages.error'), message, 'error');
            }
        });
    });

    $('#aplica').on('change', function () {
        let value = $('#aplica :selected').val();
        if (value == 0) {
            $('#captura_de_datos').hide()
            $('#new_record').hide()
            $('#asignar_na').show()
            $('#btn_submit').hide()
        } else {
            $('#captura_de_datos').show()
            $('#new_record').show()
            $('#btn_submit').show()
            $('#asignar_na').hide()
        }
    })

    $('#aplica_archivos').on('change', function () {
        let value = $('#aplica_archivos :selected').val();
        if (value == 0) {
            $('#captura_de_datos').hide()
            $('#no_aplica_archivos').val(1)
        } else {
            $('#captura_de_datos').show()
            $('#no_aplica_archivos').val(0)
        }
    })

    if ($('#aplica_archivos :selected').val() != undefined) {
        if ($('#aplica_archivos :selected').val() == 0) {
            $('#captura_de_datos').hide()
            $('#no_aplica_archivos').val(1)
        } else {
            $('#captura_de_datos').show()
            $('#no_aplica_archivos').val(0)
        }
    }

    if ($('#aplica :selected').val() != undefined) {
        if ($('#aplica :selected').val() == 0) {
            $('#captura_de_datos').hide()
            $('#no_aplica').val(1)
        } else {
            $('#captura_de_datos').show()
            $('#no_aplica').val(0)
        }
    }

    // bootstrap-select initializer
    $('.selectpicker, .per-page-selectpicker').selectpicker();

    // select2 initializer
    $('.select2-multiple').select2({
        closeOnSelect: false,
    });

    // Submit for elements per page on tables
    $('.per-page-pagination').on('change', function () {
        $(this).closest('form').submit();
    });

    // Simulate click for file_field on edit user
    $('.hover-image').on('click', function () {
        $('.update-picture').click();
    });

    // Replace profile picture on edit user
    $('.update-picture').on('change', function () {
        readURL(this);
    });

    $('#user_unit_id').on('change', function () {
        $.ajax({
            url: `/api/v1/employees/units_pres`,
            data: {unit_id: $(this).val()},
            type: 'GET',
            dataType: 'json',
            success: function (data) {
                $('#user_unit_pres_id').empty();
                for (let action of data) {
                    $('#user_unit_pres_id').append($('<option>', {
                        value: action.Id_UnidadPres,
                        text: action.Descripcion.trim()
                    }));
                }
                $('.selectpicker').selectpicker('refresh');
            },
            error: function (error) {
                toastr.warning(I18n.t('messages.try_again'));
            }
        });
    });

    $('#cancelar_requisicion').click(function (event) {
        const cancellation_input = document.createElement('textarea');
        cancellation_input.style.width = "90%";
        cancellation_input.style.height = "30%";
        let authenticityToken = $('[name="csrf-token"]')[0] && $('[name="csrf-token"]')[0].content
        swal({
            icon: "warning",
            title: "Cancelar Requisición",
            text: "¿Está seguro de cancelar?",
            content: {
                element: cancellation_input,
                attributes: {
                    placeholder: "Escriba el motivo de la cancelación",
                },
            },
            buttons: {
                cancel: 'Cancelar',
                continue: 'Confirmar'
            }

        }).then(option => {
            switch (option){
                case 'continue':
                    if (invalidString(cancellation_input.value)) {
                        swal("FAVOR DE INGRESAR MOTIVO DE CANCELACIÓN PARA CONTINUAR.", "Motivo es requerido.", 'error');
                    } else {
                        $.ajax({
                            url: '/cancel_requisicion/' +  $("#id_requisicion").val() + '/' + $("#estatus_cancelar").val(),
                            data: {
                                authenticity_token: authenticityToken,
                                motivo: cancellation_input.value,
                            },
                            type: 'POST',
                            dataType: 'json',
                            success: function (data) {
                                window.location.href = '/'
                            }
                        });
                    }
                    break;
                default:
                    break;
            }
        })
    });

    $('#validar_requisicion').click(function (event) {
        let authenticityToken = $('[name="csrf-token"]')[0] && $('[name="csrf-token"]')[0].content
        let estatus_requisicion = ($("#estatus_validar").val())

        if (estatus_requisicion == '3') {
            swal({
                icon: 'success',
                title: "Validar Requisición",
                text: "Revisar y firmar requisición.",
                buttons: {
                    cancel: I18n.t('messages.cancel'),
                    confirm: {
                        text: "Confirmar",
                        closeModal: true
                    },
                },
                // content: {
                //     element: "input",
                //     attributes: {
                //         placeholder: "Importe aproximado.",
                //         type: "number",
                //         min: "0"
                //     },
                // }
            }).then(function (value) {
                if (value) {
                // if (value >= 0 && value !== '') {
                    $.ajax({
                        url: '/validate_requisicion/' +  $("#id_requisicion").val() + '/' + $("#estatus_validar").val(),
                        data: {
                            authenticity_token: authenticityToken,
                            // importe: value
                        },
                        type: 'POST',
                        dataType: 'json',
                        success: function (data) {
                            if (data.error) {
                                let mensaje = ""
                                $.each(data.errors , function (i, val) {
                                    mensaje += val + " \n"
                                });
                                swal("FAVOR DE COMPLETAR Y GUARDAR LA REQUISICIÓN PARA PODER VALIDAR.", mensaje, 'error');
                            } else {
                                window.location.href = '/'
                            }
                        }
                    });
                }
                // else if (value === '' || value < 0) {
                //     swal("FAVOR DE INGRESAR IMPORTE CORRECTO PARA CONTINUAR.", "Importe es requerido.", 'error');
                // }
            });
        }
        else if (estatus_requisicion == '7') {
            const validation_input = document.createElement('input');
            validation_input.style.width = "90%"
            validation_input.style.height = "30%"
            validation_input.setAttribute("type", "number");
            validation_input.setAttribute("min", 0);
            let authenticityToken = $('[name="csrf-token"]')[0] && $('[name="csrf-token"]')[0].content
            swal({
                    icon: "success",
                    title: "Validar Requisición",
                    text: "Indique presupuesto disponible:",
                    content: {
                        element: validation_input,
                        attributes: {
                            placeholder: "Presupuesto disponible.",
                        },
                    },
                    buttons: {
                        cancel: 'Cancelar',
                        continue: 'Confirmar'
                    }
            }).then(option => {
                switch (option){
                    case 'continue':
                        let val = validation_input.value
                        if (invalidString(val) || isNegative(val)) {
                            swal("FAVOR DE INGRESAR PRESUPUESTO DISPONIBLE PARA PODER CONTINUAR.", "Presupuesto es requerido.", 'error');
                        } else {
                            //swal("SE VALIDO LA SUFICIENCIA PRESUPUESTAL", "", 'success');
                            $.ajax({
                                url: '/validate_requisicion/' +  $("#id_requisicion").val() + '/' + $("#estatus_validar").val(),
                                data: {
                                    authenticity_token: authenticityToken,
                                    importe: val
                                },
                                type: 'POST',
                                dataType: 'json',
                                success: function (data) {
                                    if(data.error){
                                        let mensaje = ""
                                        $.each(data.errors , function (i, val) {
                                            mensaje += val + " \n"
                                        });
                                        swal("FAVOR DE COMPLETAR Y GUARDAR LA REQUISICIÓN PARA PODER VALIDAR.", mensaje, 'error');
                                    } else {
                                        window.location.href = '/'
                                    }
                                }
                            });
                        }
                        break;
                    default:
                        break;
                }
            })
        }
        else if (estatus_requisicion == '11') {
            swal({
                icon: 'success',
                title: "Validar Requisición",
                text: "Está apunto de validar la requisición.",
                buttons: {
                    cancel: I18n.t('messages.cancel'),
                    confirm: {
                        text: "Confirmar",
                        closeModal: true
                    },
                }
            }).then(function (isConfirm) {
                if (isConfirm) {
                    $.ajax({
                        url: '/validate_requisicion/' +  $("#id_requisicion").val() + '/' + $("#estatus_validar").val(),
                        data: {
                            authenticity_token: authenticityToken
                        },
                        type: 'POST',
                        dataType: 'json',
                        success: function (data) {
                            if(data.error){
                                let mensaje = ""
                                $.each(data.errors , function (i, val) {
                                    mensaje += val + " \n"
                                });
                                swal("FAVOR DE COMPLETAR Y GUARDAR LA REQUISICIÓN PARA PODER VALIDAR.", mensaje, 'error');
                            } else {
                                // window.open('/requisition_report/'+$("#id_requisicion").val());
                                // setTimeout(function(){ window.location.href = '/'; }, 1500);
                                let url = '/requisition_report/'+$("#id_requisicion").val()
                                downloadFile(url, 'downloaded_file')
                                setTimeout(function(){ window.open(url); }, 1500);
                                setTimeout(function(){ window.location.href = '/'; }, 2500);
                            }
                        }
                    });
                }
            });
        }
        else {
            swal({
                icon: 'success',
                title: "Validar Requisición",
                text: "Está apunto de validar la requisición.",
                buttons: {
                    cancel: I18n.t('messages.cancel'),
                    confirm: {
                        text: "Confirmar",
                        closeModal: true
                    },
                }
            }).then(function (isConfirm) {
                if (isConfirm) {
                    $.ajax({
                        url: '/validate_requisicion/' +  $("#id_requisicion").val() + '/' + $("#estatus_validar").val(),
                        data: {
                            authenticity_token: authenticityToken
                        },
                        type: 'POST',
                        dataType: 'json',
                        success: function (data) {
                            if(data.error){
                                let mensaje = ""
                                $.each(data.errors , function (i, val) {
                                    mensaje += val + " \n"
                                });
                                swal("FAVOR DE COMPLETAR Y GUARDAR LA REQUISICIÓN PARA PODER VALIDAR.", mensaje, 'error');
                            } else {
                                window.location.href = '/'
                            }
                        }
                    });
                }
            });
        }
    });

    $('#firmar_requisicion').click(function (event) {
        let authenticityToken = $('[name="csrf-token"]')[0] && $('[name="csrf-token"]')[0].content
        swal({
            icon: 'success',
            title: "Enviar a Director Administrativo",
            text: "Está apunto de enviar la requisición al director administrativo.",
            buttons: {
                cancel: I18n.t('messages.cancel'),
                confirm: {
                    text: "Confirmar",
                    closeModal: true
                },
            }
        }).then(function (isConfirm) {
            if (isConfirm) {
                $.ajax({
                    url: '/validate_requisicion/' +  $("#id_requisicion").val() + '/' + $("#estatus_firmar").val(),
                    data: {
                        authenticity_token: authenticityToken
                    },
                    type: 'POST',
                    dataType: 'json',
                    success: function (data) {
                        if(data.error){
                            let mensaje = ""
                            $.each(data.errors , function (i, val) {
                                mensaje += val + " \n"
                            });
                            swal("FAVOR DE COMPLETAR Y GUARDAR LA REQUISICIÓN PARA PODER VALIDAR.", mensaje, 'error');
                        } else {
                            window.location.href = '/'
                        }
                    }
                });
            }
        });
    });

    $('#recibida_adquisiciones').click(function (event) {
        let authenticityToken = $('[name="csrf-token"]')[0] && $('[name="csrf-token"]')[0].content
        let id_requisicion = $(this).attr("data-id")

        swal({
            icon: 'success',
            title: "Cambiar Estatus",
            text: "Requisición recibida en Adquisiciones.",
            buttons: {
                cancel: I18n.t('messages.cancel'),
                confirm: {
                    text: "Confirmar",
                    closeModal: true
                },
            }
        }).then(function (isConfirm) {
            if (isConfirm) {
                $.ajax({
                    url: '/validate_requisicion/' +  id_requisicion + '/' + $("#estatus_recibida").val(),
                    data: {
                        authenticity_token: authenticityToken
                    },
                    type: 'POST',
                    dataType: 'json',
                    success: function (data) {
                        if(data.error){
                            let mensaje = ""
                            $.each(data.errors , function (i, val) {
                                mensaje += val + " \n"
                            });
                            swal("FAVOR DE COMPLETAR Y GUARDAR LA REQUISICIÓN PARA PODER VALIDAR.", mensaje, 'error');
                        } else {
                            window.location.href = '/receptor'
                        }
                    }
                });
            }
        });
    });
});

let readURL = (input) => {
    if (input.files[0]) {
        var reader = new FileReader();
        let ext = getFileExtension(input.files[0].name);
        let validImageTypes = ['gif', 'jpeg', 'png', 'jpg'];
        if (validImageTypes.includes(ext)) {
            reader.readAsDataURL(input.files[0]);
        }
    }

    reader.onload = function (e) {
        $('.profile-picture').attr('src', e.target.result);
        $('.profile-picture').attr('style', 'object-fit:cover; width:130px; height:130px;');
    }
};

let getFileExtension = (filename) => {
    return filename.split('.').pop();
};

let cascadeSelects = (source, destination, url) => {
    let ajaxRequest = (resource, edit) => {
        if (resource !== '') {
            $.get(url, {resource: resource}, function (data) {
                destination.empty();
                if (data.length > 0) {
                    for (let action of data) {
                        destination.append($('<option>', {value: action[0], text: action[1]}));
                    }
                    edit && destination.val(destination.data('value'));
                } else {
                    destination.append($('<option>', {value: '', text: I18n.t('helpers.select.no_options')}));
                }
                $('.selectpicker').selectpicker('refresh');
            })
                .fail(function () {
                    toastr.warning(I18n.t('messages.try_again'));
                });
        }
    };

    ajaxRequest(source.val(), true);

    source.on('change', function (e) {
        let resource = $(e.target).val();
        ajaxRequest(resource, false);
    });
};

// https://www.convertplug.com/plus/docs/download-pdf-file-forcefully-instead-opening-browser-using-js/
function downloadFile(fileURL, fileName) {
    if (!window.ActiveXObject) { // for non-IE
        var save = document.createElement('a');
        save.href = fileURL;
        save.target = '_blank';
        var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
        save.download = fileName || filename;
        if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
            document.location = save.href;
        } else { // window event not working here
            var evt = new MouseEvent('click', {
                'view': window,
                'bubbles': true,
                'cancelable': false
            });
            save.dispatchEvent(evt);
            (window.URL || window.webkitURL).revokeObjectURL(save.href);
        }
    } else if ( !! window.ActiveXObject && document.execCommand) { // for IE < 11
        var _window = window.open(fileURL, '_blank');
        _window.document.close();
        _window.document.execCommand('SaveAs', true, fileName || fileURL)
        _window.close();
    }
}

let undefinedOrNull = (foo) => {
    return foo === undefined || foo === null
};

let invalidString = (str) => {
    return undefinedOrNull(str) || str === ''
};

function isNegative(num) {
    if (Math.sign(num) === -1) {
        return true;
    }
    return false;
}

export {cascadeSelects};
